import { getPriceProd } from "./utilities";

const InfiniteScroll = {
  params: window._pagination,
  priceProds: {
    selector: '[data-update-price]',
    attr: 'update-price',
  },
  productsWrapper: document.querySelectorAll('.section-list-products')[0],
  productWrapper: document.querySelectorAll('.list-products .products')[0],
  button: document.querySelector('[data-load-more]'),
  minSearchProducts: 24,
  autoLoadAttempts: 0,
  maxAutoLoadAttempts: 3,
  isLoading: false,
  stopLoading: function () {
    const button = this.button;
    if (button != null) button.parentElement.removeChild(button);
  },
  setCurrentPage: function (_number) {
    const totalPages = this.params.totalPages;

    if (_number <= totalPages) {
      this.params.currentPage = _number;

      if (this.params.currentPage >= totalPages) this.stopLoading();

      if (_number < totalPages) return (this.params.nextUrl = this.params.pages[_number].url);
    }
  },
  setScript: function (script) {
    const newScript = document.createElement('script');
    newScript.innerText = script.innerText;
    return document.body.appendChild(newScript);
  },
  loadProducts: async function () {
    const nextUrl = this.params.nextUrl;
    const response = await fetch(nextUrl);
    const data = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');

    // Busca por scripts para compra rápida
    const scripts = doc.querySelectorAll('[data-variants-script]');
    if (scripts.length > 0) scripts.forEach((script) => {
      InfiniteScroll.setScript(script);
    });

    return doc.querySelectorAll('.product-block');
  },
  updatePrice: function () {
    getPriceProd();
  },
  isSearchFiltered: function () {
    return this.productsWrapper && this.productsWrapper.hasAttribute('data-search-filtered');
  },
  getVisibleProductsCount: function () {
    if (!this.productWrapper) return 0;
    return this.productWrapper.querySelectorAll('.product-block').length;
  },
  updateSearchFallback: function () {
    if (!this.isSearchFiltered()) return;

    const fallback = this.productsWrapper.querySelector('[data-search-loading-fallback]');
    if (!fallback) return;

    const hasProducts = this.getVisibleProductsCount() > 0;
    if (hasProducts) {
      fallback.parentElement.removeChild(fallback);
      return;
    }

    if (this.button == null || !this.button.isConnected) {
      fallback.textContent = 'Nenhum produto encontrado.';
    }
  },
  shouldKeepLoadingSearch: function () {
    if (!this.isSearchFiltered()) return false;
    if (this.button == null || !this.button.isConnected) return false;
    if (this.params.currentPage >= this.params.totalPages) return false;
    return this.getVisibleProductsCount() < this.minSearchProducts;
  },
  getNextPage: async function () {
    if (this.isLoading) return;
    
    const currentPage = this.params.currentPage;
    const wrapper = this.productsWrapper;
    const productWrapper = this.productWrapper;
    let hasAccess = true;

    if (!wrapper.classList.contains('-searching')) {
      this.isLoading = true;
      this.productsWrapper.classList.add('-searching');
      this.button.classList.add('-searching');

      const newProducts = await this.loadProducts();

      newProducts.forEach((product) => {
        productWrapper.appendChild(product);
      });

      if (window.Client && typeof window.Client.getClient === 'function' && typeof window.Client.syncCatalogVisibility === 'function') {
        const client = await window.Client.getClient();
        hasAccess = window.Client.hasCatalogAccess(client);
        window.Client.syncCatalogVisibility(hasAccess);
      }

      this.setCurrentPage(currentPage + 1);

      if (window.ProductPurchase)
        window.ProductPurchase.init(true);

      if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
        window.lazyLoadInstance.update();
      }
      this.updatePrice();
      this.updateSearchFallback();

      wrapper.classList.remove('-searching');
      this.button.classList.remove('-searching');
      this.isLoading = false;
    
      if (!hasAccess) {
        const restrictedProducts = [...newProducts].filter(product => product.classList.contains('-catalog') || product.classList.contains('-pronta-entrega'))
        const visibleProducts = [...newProducts].length - restrictedProducts.length

        if (visibleProducts < 4 && [...newProducts].length >= 24 && this.autoLoadAttempts < this.maxAutoLoadAttempts) {
          this.autoLoadAttempts++;
          // Adiciona delay para evitar rate limiting
          setTimeout(() => {
            this.getNextPage();
          }, 800);
        }
      }

      if (this.shouldKeepLoadingSearch() && this.autoLoadAttempts < this.maxAutoLoadAttempts) {
        this.autoLoadAttempts++;
        // Adiciona delay para evitar rate limiting
        setTimeout(() => {
          this.getNextPage();
        }, 800);
      }
    }
  },

  init: function () {
    const _this = this;
    const button = _this.button;

    // Verifica se há paginação definida antes de iniciar
    if (typeof _this.params != undefined) {

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      if (button != null) {
        const observer = new IntersectionObserver((entries) => {

          // isIntersecting retorna true quando o elemento entra em página
          if (entries[0].isIntersecting) {
            console.log('entries: ', entries[0]);
            _this.getNextPage();
          }

          // threshold 1 só chama o callback acima quando o elemento observado estiver full na tela
        }, { threshold: 0 });

        observer.observe(button);
      }

      if (_this.isSearchFiltered() && _this.getVisibleProductsCount() === 0 && button != null) {
        _this.autoLoadAttempts = 0; // Reset para busca nova
        _this.getNextPage();
      }

      // _this.updateSearchFallback();
    }
  },
};

export default InfiniteScroll;